import { useGlobalStore } from '../../../Common/store';
import bindActions from '../../../Common/actions';
import verifyCodeReducer from '../../store/verifyCode';

const { actions } = verifyCodeReducer;

/**
 * useVerifyCode Custom Hook
 */
const useVerifyCode: any = () => {
	const { state , dispatch } = useGlobalStore();

	// List of Props
	const { verifyCode } = state;

	// List of Actions
	const {
		handleVerifyCode 
	} = actions;

	// Bind Actions
	const verifyCodeActions = bindActions({
		handleVerifyCode 
	}, dispatch);

	return { verifyCode, ...verifyCodeActions };
}

export default useVerifyCode;
